<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sGj2Pg/tc-custom/9781788636346.jpg?1718282658919" alt="This image is the cover for the book Mistress of Green Tree Mill"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mistress of Green Tree Mill
      </h1>
      <p class="bookDescription body article font2">
        <p>  </p><p><b>Tragedy transforms a girl into the only woman jute mill owner in the Scottish city of Dundee in this heartwarming, rags-to-riches historical saga.</b></p><p> At the age of eleven young Lizzie Mudie’s life changes forever. With the death of her mother in the most shocking disaster Dundee has ever seen, Lizzie is forced to grow up quickly. </p><p> She discovers a strength beyond her years and when an unexpected legacy bestows her the dilapidated Green Tree Mill, she is determined to turn things around. Lizzie becomes a formidable mistress, but is she prepared for the price she—and those she loves—will have to pay for her success? </p><p><b>An excellent choice for fans of Dilly Court and Tessa Barclay.</b></p><p><b>Praise for <i>Mistress of Green Tree Mill</i></b></p><p><b> </b><b>“A lovely, warm, natural read, full of colour and background detail, rich in people and places.” —<i>Woman’s World</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elisabeth McNeill
      </h2>
      
      <p class="authorDescription body article">Elisabeth McNeill was a long-established freelance journalist and broadcaster who wrote five non-fiction books and 26 novels. She lived with a miniature dachshund in the oldest inhabited village on the Scottish borders, where she spent most of her school days.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?20a0160e